import * as React from "react";
const SvgFiRrPhonePlus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-phone-plus_svg__a)">
      <path
        fill="#062147"
        d="M14 5a1 1 0 0 1 1-1h3V1a1 1 0 1 1 2 0v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0V6h-3a1 1 0 0 1-1-1m9.094 11.74a3.1 3.1 0 0 1 0 4.376l-.912 1.05a6.15 6.15 0 0 1-4.421 1.833C10.126 23.999 0 13.874 0 6.238 0 4.565.634 3.01 1.784 1.863L2.933.86C4.088-.3 6.054-.301 7.26.907c.031.03 1.883 2.438 1.883 2.438a3.1 3.1 0 0 1-.006 4.28L7.978 9.083c1.458 3.309 3.733 5.589 6.932 6.947l1.464-1.165a3.1 3.1 0 0 1 4.282-.007s2.407 1.853 2.438 1.883m-1.376 1.454s-2.395-1.842-2.425-1.873a1.12 1.12 0 0 0-1.549 0 471 471 0 0 1-2.044 1.635 1 1 0 0 1-.979.15c-4.141-1.58-7.108-4.543-8.821-8.811a1 1 0 0 1 .146-.995s1.607-2.018 1.635-2.044a1.097 1.097 0 0 0 0-1.55c-.03-.03-1.872-2.422-1.872-2.422A1.095 1.095 0 0 0 4.3 2.32L3.15 3.326C2.428 4.05 2.004 5.1 2.004 6.239 2.004 13.196 11.776 22 17.766 22c1.138 0 2.188-.425 2.959-1.197l.912-1.05c.459-.463.473-1.13.085-1.56z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-phone-plus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPhonePlus;
